// extracted by mini-css-extract-plugin
export default {"wrapper":"progress-bar_wrapper__683HK","progress":"progress-bar_progress__E-XPd","percent":"progress-bar_percent__l8x4a"};